// Send Refer Invitation
export const SEND_REFERRAL_INVITATION_REQUEST = 'SEND_REFERRAL_INVITATION_REQUEST';
export const SEND_REFERRAL_INVITATION_DONE = 'SEND_REFERRAL_INVITATION_DONE';
export const SEND_REFERRAL_INVITATION_FAILED = 'SEND_REFERRAL_INVITATION_FAILED';
export const SEND_REFERRAL_INVITATION_RESET = 'SEND_REFERRAL_INVITATION_RESET';
